import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import router from './router'
import store from './store'
import VueExcelXlsx from "vue-excel-xlsx";
import Vue3Toastify from 'vue3-toastify'
import 'vue3-toastify/dist/index.css';
import { isPermissionError } from '@/common/static_data/constants';

const notificationOptions = {
  autoClose: 3000,
  closeButton: false,
  position: 'top-center',
  style: { width: 'fit-content' }
}

const pinia = createPinia();

const app = createApp(App);

app.config.errorHandler = (error, vm, info) => {
  if (isPermissionError(error)) {
    console.warn('Firebase permission error handled:', error.message);
    return;
  }

  console.error('Vue error:', error, info);
};

window.addEventListener('unhandledrejection', (event) => {
  if (isPermissionError(event.reason)) {
    console.warn('Unhandled Firebase permission error:', event.reason.message);
    event.preventDefault(); 
    return;
  }
});

app.use(pinia)
  .use(Vue3Toastify, notificationOptions)
  .use(VueExcelXlsx)
  .use(store)
  .use(router)
  .mount('#app')
  